import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_QUICK_SUPPORT,
    getQuickSupportFail,
    getQuickSupportSuccess
} from '../action/getQuickSupport'

// api 
import getQuickSupportApi from '../api/getQuickSupportApi'

export function* getQuickSupportSaga(action) {
    try {
        const response = yield call(() => getQuickSupportApi(action.params))
        console.log("REsponse", response.data.status)
        console.log("myres", response.data)
        if (response.data.statusCode === 200) {
            yield put(getQuickSupportSuccess(response, action))
        } else {
            yield put(getQuickSupportFail(response, action))
        }
    }
    catch (e) {
        yield put(getQuickSupportFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_QUICK_SUPPORT, getQuickSupportSaga)
}